import { render, staticRenderFns } from "./SchedulePaymentsSettingsEditForm.vue?vue&type=template&id=3712ecb8"
import script from "./SchedulePaymentsSettingsEditForm.vue?vue&type=script&lang=js"
export * from "./SchedulePaymentsSettingsEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports